import { Routes } from '@angular/router';
import { BookingSectionComponent } from './booking/containers/booking-section/booking-section.component';
import { StepLocationComponent } from './booking/containers/step-location/step-location.component';
import { StepTimeComponent } from './booking/containers/step-time/step-time.component';
import { StepHubDropComponent } from './booking/containers/step-hub-drop/step-hub-drop.component';
import { StepPaymentComponent } from './booking/containers/step-payment/step-payment.component';
import { UpsellComponent } from './booking/components/upsell-timeslot/upsell.component';
import { D2dBookingSwitchComponent } from './booking/components/d2d-booking-switch/d2d-booking-switch.component';
import { FlybackComponent } from './booking/containers/flyback/flyback.component';
import { Error404Component } from './error-pages/containers/error-404/error-404.component';
import { Error500Component } from './error-pages/containers/error-500/error-500.component';
import { VerifyEmailSectionComponent } from './login/containers/verify-email-section/verify-email-section.component';
import { AccessAccountSectionComponent } from './login/containers/access-account-section/access-account-section.component';
import { ForgotPasswordSectionComponent } from './login/containers/forgot-password-section/forgot-password-section.component';
import { ResetPasswordSectionComponent } from './login/containers/reset-password-section/reset-password-section.component';
import { RegisterSectionComponent } from './register/containers/register-section/register-section.component';
import { ValidateEmailSectionComponent } from './register/containers/validate-email-section/validate-email-section.component';
import { SetPasswordSectionComponent } from './register/containers/set-password-section/set-password-section.component';
import { RegisterDetailsSectionComponent } from './register/containers/register-details-section/register-details-section.component';
import { VerifySectionComponent } from './verify/containers/verify-section/verify-section.component';

export const appRoutes: Routes = [
  {
    path: 'flight-finder',
    loadChildren: () => import('../app/flight-finder/flight-finder.module').then(m => m.FlightFinderModule)
  },
  {
    path: 'abc',
    component: BookingSectionComponent,
    data: { bookingProduct: 'abc' },
    children: [
      {
        path: 'collection-location',
        component: StepLocationComponent,
        data: { title: 'Choose collection location' }
      },
      // {
      //   path: 'collection-post-office',
      //   component: StepHubDropComponent,
      //   data: { title: 'Choose collection post-office' }
      // },
      {
        path: 'collection-time',
        component: StepTimeComponent,
        data: { title: 'Choose collection time' }
      },
      {
        path: 'payment',
        component: StepPaymentComponent,
        data: { title: 'Confirm payment' }
      },
      {
        path: 'upgrade-ccd',
        component: UpsellComponent,
        data: { title: 'Upsell' }
      },
    ]
  },
  {
    path: 'ccd',
    component: BookingSectionComponent,
    data: { bookingProduct: 'ccd' },
    children: [
      {
        path: 'delivery-location',
        component: StepLocationComponent,
        data: { title: 'Choose delivery location' }
      },
      {
        path: 'delivery-time',
        component: StepTimeComponent,
        data: { title: 'Choose delivery time' }
      },
      {
        path: 'payment',
        component: StepPaymentComponent,
        data: { title: 'Confirm payment' }
      },
      {
        path: 'upgrade-abc',
        component: UpsellComponent,
        data: { title: 'Upsell' }
      },
    ]
  },
  {
    path: 'redirectingTo',
    component: D2dBookingSwitchComponent
  },
  {
    path: 'fly-back-details',
    component: FlybackComponent
  },
  {
    path: 'complete',
    loadChildren: () => import('../app/booking-complete/booking-complete.module').then(m => m.CompleteSectionModule)
  },
  {
    path: 'my-account',
    loadChildren: () => import('../app/my-account/my-account-section.module').then(m => m.MyAccountSectionModule),
  },
  {
    path: 'login',
    component: VerifyEmailSectionComponent,
    data: { title: 'Login to your account' }
  },
  {
    path: 'access-account',
    component: AccessAccountSectionComponent,
    data: { title: 'Access your account' }
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordSectionComponent,
    data: { title: 'Reset your password' }
  },
  {
    path: 'reset-password',
    component: ResetPasswordSectionComponent,
    data: { title: 'Reset your password' }
  },
  {
    path: 'register',
    component: RegisterSectionComponent,
    data: { title: 'Register a new account' }
  },
  {
    path: 'validate-email',
    component: ValidateEmailSectionComponent,
    data: { title: 'Validate your email address' }
  },
  {
    path: 'set-password',
    component: SetPasswordSectionComponent,
    data: { title: 'Set your password' }
  },
  {
    path: 'register-details',
    component: RegisterDetailsSectionComponent,
    data: { title: 'Your registration details' }
  },
  {
    path: 'verify',
    component: VerifySectionComponent,
    data: { title: 'AirPortr' }
  },
  {
    path: 'error-500',
    component: Error500Component,
    data: { title: 'AirPortr' }
  },
  {
    path: 'error-404',
    component: Error404Component,
    data: { title: 'AirPortr' }
  },
  {
    path: 'quote',
    redirectTo: 'flight-finder/search?start-booking=true',
    pathMatch: 'full'
  },
  {
    path: '',
    redirectTo: 'flight-finder/search?start-booking=true',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/error-404'
  }
];
